import { Area } from 'os/shared/utils/src/types/Area';
import { Photo, Size } from 'ff-canvas';
import type { FaceDetection } from 'ff-face-detection';
import { calculateOffset } from './calculateOffset';
import { calculateZoom } from './calculateZoom';
import { shiftCropToFaceCentered } from './shiftCropToFaceCentered';
import { sliceCropToSize } from './sliceCropToSize';

export const calculateCoverCropForFfCanvas = (
    imageContainerArea: Area,
    imageSize: Size,
    cropBox: Area,
    autoFaceCenter: boolean,
    detections: FaceDetection[]
): Partial<Photo> => {

    // The crop tool does not enforce aspect ratio. We have to slice `cropBox`
    // to the image-container's ratio here. (Yes, we actually crop the crop box. This
    // was the simplest solution due to limitations in the crop tool library.)

    let actualCropBox = sliceCropToSize(cropBox, imageContainerArea);

    if (autoFaceCenter && detections) {
        actualCropBox = shiftCropToFaceCentered(actualCropBox, detections, imageSize);
    }

    const zoom = calculateZoom(actualCropBox, imageSize, 'cover');
    const offset = calculateOffset(imageSize, actualCropBox, imageContainerArea, zoom);

    return {
        innerZoom: zoom,
        innerOffsetX: offset.x,
        innerOffsetY: offset.y
    };
};